<template>
    <div ref="markMathRenderer"
         class="mark-math-div"
         :class="userClassName"
         v-html="renderedMarkMath" />
</template>


<script>

// 资源下载地址
// https://cdn.jsdelivr.net/npm/mathjax@3.2.2/es5/

import { marked } from "marked";
import 'mathjax/es5/tex-mml-chtml';

export default {
  name: "MarkRenderer2.vue",
  props: {
    content: {
      type: String,
      required: true
    },
    userClass: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      renderedMarkMath: '',
      userClassName: ''
    };
  },
  watch: {
    content: {
      immediate: true,
      async handler(newContent) {
        await this.renderMath(newContent);
      }
    },
    userClass: {
      immediate: true,
      async handler(newClass) {
        this.userClassName = newClass;
      }
    }
  },
  methods: {
    renderMath: function (newContent) {
      this.renderedMarkMath = marked(this.prepareNewContent(newContent));
      this.$nextTick(() => {
        if (window.MathJax) {
          window.MathJax.typesetPromise([this.$refs.markMathRenderer]).catch((err) => console.error(err.message));
        } else {
          console.error('MathJax is not loaded');
        }
      });
    },
    prepareNewContent: function (text) {
      // 使用两个或以上的换行符作为段落分隔符
//    const paragraphs = text.split(/\n{2,}/); //使用两个或以上的换行符作为段落分隔符
      const paragraphs = text.split(/\n\n/); //使用两个换行符作为段落分隔符

      // 保留段落内部的换行符，并用 <div> 包裹每段
      const wrapped = paragraphs.map(p => `<div>\n${p}\n</div>`);

      // 拼接所有段落
      return wrapped.join('\n');
    }

  }
}
</script>

<style>
.mark-math-div {
  padding: 5px;
  white-space: pre-wrap;
}
.mark-math-div p {
  margin: 0;
}
.mark-math-div table {
  background-color: black;
  border-spacing: 1px;
}
.mark-math-div table tr {
  background-color: white;
}
.mark-math-div table tr th {
  padding: 5px;
}
.mark-math-div table tr td {
  padding: 5px;
}
</style>
